"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyMessageSignature = exports.getCoreMessageFromFullMessage = exports.getSignedMessageWithPrivateKey = exports.getSignedMessageWithSigner = exports.getSignedMessageWithMetamaskProvider = void 0;
const ethers_1 = require("ethers");
const MagicDivider = '\n---------\n';
const Version = '1.0.0';
function createMessage(account) {
    return {
        account: account,
        nonce: new Date().getTime() + getRandomInt(-1000, 1000),
        timestamp: new Date().getTime(),
        version: Version
    };
}
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}
/**
 * Get message and signature with metamask provider, used for client-to-server verification.
 */
function getSignedMessageWithMetamaskProvider(account, metamaskProvider, humanMessage = '') {
    return __awaiter(this, void 0, void 0, function* () {
        const web3 = new ethers_1.ethers.providers.Web3Provider(metamaskProvider); // create web3 instance
        const signer = web3.getSigner();
        return yield getSignedMessageWithSigner(account, signer, humanMessage);
    });
}
exports.getSignedMessageWithMetamaskProvider = getSignedMessageWithMetamaskProvider;
/**
 * Get message and signature with a web3 signer, such as metamask signer, used for client-to-server verification.
 */
function getSignedMessageWithSigner(account, signer, humanMessage = '') {
    return __awaiter(this, void 0, void 0, function* () {
        if (!humanMessage) {
            humanMessage = 'Welcome to Storyverse!\n\nClick sign to authorize your wallet.\n\nThis request will not trigger a blockchain transaction or cost any gas fees.\n';
        }
        const message = createMessage(account);
        const fullMessage = humanMessage + MagicDivider + JSON.stringify(message);
        const signature = yield signer.signMessage(fullMessage);
        return {
            message: fullMessage,
            signature: signature
        };
    });
}
exports.getSignedMessageWithSigner = getSignedMessageWithSigner;
/**
 * Get message and signature with a private key, used for server-to-server verification.
 */
function getSignedMessageWithPrivateKey(account, privateKey) {
    return __awaiter(this, void 0, void 0, function* () {
        const message = createMessage(account);
        const humanMessage = 'This is auto-generated message for server to server communication.';
        const fullMessage = humanMessage + MagicDivider + JSON.stringify(message);
        const provider = new ethers_1.ethers.providers.AlchemyProvider();
        const signer = new ethers_1.ethers.Wallet(privateKey, provider);
        const signature = yield signer.signMessage(fullMessage);
        return {
            message: fullMessage,
            signature: signature
        };
    });
}
exports.getSignedMessageWithPrivateKey = getSignedMessageWithPrivateKey;
function getCoreMessageFromFullMessage(fullMessage) {
    const indexOfMagicDivider = fullMessage.indexOf(MagicDivider);
    const indexOfJson = indexOfMagicDivider + MagicDivider.length;
    const jsonMessage = JSON.parse(fullMessage.substring(indexOfJson));
    return jsonMessage;
}
exports.getCoreMessageFromFullMessage = getCoreMessageFromFullMessage;
/**
 * Verify message and signature, returns core message on success.
 * @returns {TMessageForSigning}
 */
function verifyMessageSignature(fullMessage, signature) {
    const accountFromSignatureVerification = ethers_1.ethers.utils.verifyMessage(fullMessage, signature);
    const jsonMessage = getCoreMessageFromFullMessage(fullMessage);
    const accountFromMessage = jsonMessage.account;
    // reason to toLowerCase(): https://ethereum.stackexchange.com/questions/2045/is-ethereum-wallet-address-case-sensitive
    if (accountFromMessage.toLowerCase() !== accountFromSignatureVerification.toLowerCase()) {
        throw 'accountFromMessage not equal to accountFromSignatureVerification';
    }
    return jsonMessage;
}
exports.verifyMessageSignature = verifyMessageSignature;
